
import React from 'react';
import { useTranslation } from 'react-i18next';

const InfoBox: React.FC = () => {
  const { t } = useTranslation();
  
  return (
    <div className="mb-8">
      <div className="p-4 bg-gray-50 rounded-lg border">
        <div>
          <h3 className="font-medium mb-2">{t('tips.responseTitle')}</h3>
          <ul className="list-disc pl-5 space-y-1">
            <li>{t('tips.aimForBroadAudience')}</li>
            <li>{t('tips.mostResponsesLength')}</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default InfoBox;

